import { create } from 'zustand';
import type { Device, Position } from '@/api/types';

interface FleetState {
  devices: Map<number, Device>;
  positions: Map<number, Position>;
  setDevices: (devices: Device[]) => void;
  setPositions: (positions: Position[]) => void;
  upsertDevices: (devices: Device[]) => void;
  upsertPositions: (positions: Position[]) => void;
  reset: () => void;
}

export const useFleetStore = create<FleetState>((set) => ({
  devices: new Map(),
  positions: new Map(),
  setDevices: (devices) =>
    set(() => ({ devices: new Map(devices.map((d) => [d.id, d])) })),
  setPositions: (positions) => {
    const map = new Map<number, Position>();
    for (const p of positions) {
      if (p.deviceId == null) continue;
      const existing = map.get(p.deviceId);
      if (!existing || new Date(p.fixTime) > new Date(existing.fixTime)) {
        map.set(p.deviceId, p);
      }
    }
    set({ positions: map });
  },
  upsertDevices: (devices) =>
    set((state) => {
      const next = new Map(state.devices);
      for (const d of devices) next.set(d.id, { ...next.get(d.id), ...d });
      return { devices: next };
    }),
  upsertPositions: (positions) =>
    set((state) => {
      const next = new Map(state.positions);
      for (const p of positions) {
        if (p.deviceId == null) continue;
        const existing = next.get(p.deviceId);
        if (!existing || new Date(p.fixTime) >= new Date(existing.fixTime)) {
          next.set(p.deviceId, p);
        }
      }
      return { positions: next };
    }),
  reset: () => set({ devices: new Map(), positions: new Map() }),
}));
